import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import getOption from './getOption';

export default function useShowPrice(ad: any): boolean {
  const userLoggedIn: boolean = useSelector((state: RootState) => {
    return state.user.loggedIn;
  });
  const auction = ad?.ad_auction ? ad.ad_auction : ad;
  const auctionIsLive = auction?.time_end_extended
    ? new Date(auction.time_end_extended).getTime() < new Date().getTime()
      ? false
      : true
    : false;
  const hasAuctions = getOption('HAS_AUCTIONS');
  if (!hasAuctions) {
    if (ad.sold) {
      return false;
    }
    if (ad.status === 'onhold') {
      return true;
    }
    if (ad.status !== 'published') {
      return false;
    }
    return true;
  }
  if (userLoggedIn) {
    return true;
  }
  if (auctionIsLive) {
    return true;
  }
  return false;
}
